import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            console.log('error, rendering fallback', this.props.fallback);
            return this.props.fallback || _jsx(_Fragment, {}, void 0);
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map